import { normalize } from 'normalizr'
import { arrayOfRates } from '../../easymsRateSchema'

export default rates => normalize(rates, arrayOfRates)



// WEBPACK FOOTER //
// ./src/adapters/parsers/easymsParsers/easymsRates.js